// auto-generated by Typewriter template _enums.tst from PortCall.Models\CoordinationCards\CoordinationCurrency.cs
export enum CoordinationCurrency { 
    Current = 0,
    Deprecated = 10
}

export const CoordinationCurrencyDisplayName : { [val : number] : string } = { 
    0: 'Current',
    10: 'Deprecated'
}

export const CoordinationCurrencys : { Id : CoordinationCurrency, Name : string }[] = [ 
    { Id: CoordinationCurrency.Current, Name: 'Current' },
    { Id: CoordinationCurrency.Deprecated, Name: 'Deprecated' }
]



// WEBPACK FOOTER //
// ./server/enums/CoordinationCurrency.ts